<!-- START TOPBAR -->
<div class='logo-area' style="font-size: 30px;color: #FFF;background: #FFF;" [ngClass]="{'text-center':windowWidth>768}"
  (window:resize)="onResize($event)">
  <!-- <img style="height: 60px;width: 200px;" class="img-responsive"
    src="https://www.forushealth.com/assets/img/forus-health.svg" alt="Forus Logo" /> -->
    <img style="height: 60px;width: 200px;" class="img-responsive"
    src="assets/images/fourshealth-header-logo.svg" alt="Forus Logo" />
</div>
<div class='quick-area'>
  <div class='pull-left slantit'>
    <ul class="info-menu left-links list-inline list-unstyled">
      <li class="sidebar-toggle-wrap">
        <a title="Expand sidebar" style="cursor:pointer;" data-toggle="sidebar" class="sidebar_toggle" (click)="toggleSidebar()">
          <i class="material-icons">menu</i>
        </a>
      </li>
    </ul>
  </div>
  <div class="pull-left pagetitle">
    <span class='line'></span>
    <h1>{{screenInfo.title}}</h1>
    <div></div>
  </div>
  <!-- <div class="pull-left quickleft" style=''>
    <ul class="info-menu right-links list-inline list-unstyled">
      <li class="dropdown tab " uib-dropdown>
        <a  href="javascript:;" class="dropdown-toggle toggle" uib-dropdown-toggle>
          <i class="material-icons">email</i>
          <span class="badge badge-primary">7</span>
        </a>
        <ul class="dropdown-menu  messages animated fadeIn">
          <li class="list">

          </li>
          <li class="external">
            <a href="javascript:;">
              <span>Read All Messages</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="dropdown tab " uib-dropdown>
        <a href="javascript:;" class="dropdown-toggle toggle" uib-dropdown-toggle>
          <i class="material-icons">notifications</i>
          <span class="badge badge-accent">3</span>
        </a>
        <ul class="dropdown-menu  notifications animated fadeIn">
          <li class="total">
            <span class="small">
              You have <strong>3</strong> new notifications.
              <a href="javascript:;" class="pull-right">Mark all as Read</a>
            </span>
          </li>
          <li class="list">

          </li>
          <li class="external">
            <a href="javascript:;">
              <span>Read All Notifications</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="menu-profile-toggle tab">
        <a href class="profile_toggle" ng-click="app.settings.menuProfile = !app.settings.menuProfile ">
          <i class="material-icons">person</i>
        </a>
      </li>
    </ul>
  </div> -->
  <!-- <div class='pull-left searchbar'>
    <ul class="info-menu right-links list-inline list-unstyled">
      <li class="hidden-md hidden-sm hidden-xs searchform" searchgroup>
        <div class="input-group">
          <span class="input-group-addon input-focus">
            <i class="material-icons">search</i>
          </span>
          <form action="search-page.html" method="post">
            <input type="text" class="form-control animated fadeIn" placeholder="">
            <input type='submit' value="">
          </form>
        </div>
      </li>
    </ul>
  </div> -->
  <div class='pull-right quickright'>
    <ul class="info-menu right-links list-inline list-unstyled">

      <!-- <li class="dropdown profile tab" uib-dropdown>
        <a href class="dropdown-toggle toggle" uib-dropdown-toggle>
          <img ng-if="app.type == 'hospital'" src="../../../assets/images/profile-hospital.jpg" alt="user-image" class="img-circle img-inline">
          <span class="profile-status available"></span>

          <span class='hidden-sm hidden-md hidden-xs'>John Carter </span> 
          <i class="material-icons hidden-md hidden-sm hidden-xs">expand_more</i>
        </a>
        <ul class="dropdown-menu dropdown-menu-right profile animated fadeIn">
          <li>
            <a ui-sref="app.dashboard">
              <i class="material-icons">settings</i> Settings
            </a>
          </li>
          <li>
            <a ui-sref="app.ui.profile">
              <i class="material-icons">person</i> Profile
            </a>
          </li>
          <li>
            <a ui-sref="app.ui.faq">
              <i class="material-icons">help</i> Help
            </a>
          </li>
          <li class="last">
            <a ui-sref="access.login">
              <i class="material-icons">lock</i> Logout
            </a>
          </li>
        </ul>
      </li> -->
      <li class="chat-toggle-wrapper chat-slant">
        <a href="javascript:;" data-toggle="chatbar" title="Logout" (click)="logout()" class="toggle_chat logout-button"
          ng-click="app.settings.chatFolded = !app.settings.chatFolded; menuChatToggle('chat',app.settings.chatFolded) ">
          <span class="logout-title">Logout</span>
          <i class="material-icons logout-icon" style="font-size: 30px;margin-top: 15px;">exit_to_app</i>
        </a>
      </li>
    </ul>
  </div>
</div>